<template>
  <div class="boxCanvas" v-show="showQrCode">
    <div class="canvasBg"></div>
    <div class="qrCodeBox">
      <div class="right">
        <img class="guanbi" @click="closeCode" src="@/assets/image/关闭.png" />
        <div class="title">修改密码</div>
        <div class="form">
          <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="姓名" prop="realName">
              <el-input v-model="form.realName" placeholder="请输入姓名" />
            </el-form-item>
            <el-form-item label="身份证号" prop="idCardNo">
              <el-input v-model="form.idCardNo" placeholder="请输入身份证号" />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                type="password"
                v-model="form.newPassword"
                placeholder="请输入新密码" />
            </el-form-item>
            <el-form-item label="确认密码" prop="password">
              <el-input
                type="password"
                v-model="form.password"
                placeholder="请确认密码" />
            </el-form-item>
            <button
              type="button"
              class="moni"
              @click="setPassword"
              style="
                display: block;
                border: none;
                width: 150px;
                margin: 0 auto;
              ">
              提交
            </button>
          </el-form>
        </div>
      </div>
    </div>
    <Verify
      @success="success"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"></Verify>
  </div>
</template>

<script>
import { captcha, setPassword } from "@/api/user";
import JSEncrypt from "jsencrypt";
import Verify from "@/components/verifition/Verify.vue";
export default {
  components: {
    Verify,
  },
  data() {
    return {
      showQrCode: false,
      form: {
        realName: undefined,
        idCardNo: undefined,
        newPassword: undefined,
        password: undefined,
      },
      rules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请确认密码", trigger: "blur" }],
      },
      showTime: false,
      time: 60,
      publicKey: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvHdaUj121trhuXVQNTuweOAQIIGk1DOMIsN2Wt4F0B9mLtDJslW6dWVz8A4u3mZ6Jhu4SizXXWq63mD6Xaq/yUC8NkH3GBS8XCClQqZ6eIJR8zKBNkrpRQMgo0apiRThoksGnd/1AE+vrgZZZ9g/1bhyn2KJ2bY6qZJGb56XyKFBv7zciZ6q/S3KJruClk5FccwFwtQbsegkAyZOm+3wXW/Z2gxywVZvdbh+12abkFusRI0EdwFJspC7gYakG9Ml1iPW4kYLr2hXK2RrTGOUAo7VwI/QkNkJqaybb/A5G1vuvNqZjpOSWZhCBcM2Iheo6NSk00MX1upwAHB6e8hpRQIDAQAB`,
    };
  },
  methods: {
    async success(captchaData) {
      const encryptor = new JSEncrypt();
      // 使用jsencrypt库进行加密
      encryptor.setPublicKey(this.publicKey);
      setPassword({
        ...this.form,
        idCardNo: encryptor.encrypt(this.form.idCardNo),
        password: undefined,
        newPassword: encryptor.encrypt(this.form.newPassword),
        captchaData: captchaData,
      }).then((res) => {
        if (res.code == 200) {
          this.showQrCode = false;
          this.$message.success("修改密码成功！");
        } else {
          if (res.msg) {
            this.$message.warning(res.msg);
          } else {
            this.$message.warning("修改密码失败");
          }
        }
      });
    },
    setPassword() {
      if (this.form.password != this.form.newPassword) {
        return this.$message.warning("密码不一致, 请重新输入");
      }
      this.$refs.verify.show();
    },
    async sendCode() {
      if (!this.form.phoneNumber) {
        this.$message.warning("请先输入手机号！");
        return;
      }
      this.time = 60;
      this.showTime = true;
      let timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          this.showTime = false;
          clearInterval(this.timer);
        }
      }, 1000);
      let res = await captcha({
        phoneNumber: this.form.phoneNumber,
        smsScene: "CHANGE_PASSWORD",
      });
      // 模拟发送验证码的逻辑
      this.$message.success("验证码已发送到您的手机！");
    },
    async openRegister() {
      this.showQrCode = true;
    },
    closeCode() {
      this.showQrCode = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.moni {
  flex: 1;
  background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%);
  color: #fff;
  padding: 0px 10px;
  border-radius: 5px;
  cursor: pointer;
  height: 30px;
}

.jixu {
  flex: 1;
  padding: 0px 10px;
  border-radius: 5px;
  cursor: pointer;
  height: 30px;
  border: 1px solid #e1e1e1;
  font-weight: normal;
  font-size: 14px;
  color: #4a4a4a;
}
.boxCanvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 102;
  .canvasBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .qrCodeBox {
    position: absolute;
    background: #fff;
    height: 400px;
    border-radius: 10px;
    overflow: hidden;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    align-items: center;
    .left {
      padding: 20px;
      width: 300px;
      height: 100%;
      background: #f7f7f7;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      font-size: 20px;
      .logo {
        width: 100%;
        margin-bottom: 50px;
      }
    }
    .right {
      width: 500px;
      padding: 20px;
      padding-top: 30px;
      box-sizing: border-box;
      .title {
        text-align: center;
        font-size: 22px;
        margin-bottom: 10px;
      }
      .main {
        border-top: 1px solid #dcdfe6;
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 10px;
      }
      .button {
        width: 100%;
        margin: 0 auto;
        color: #fff;
      }
    }
  }
}
</style>
